<template>
	<v-app>
		<transition name="route" mode="out-in">
			<router-view />
		</transition>
	</v-app>
</template>

<script>

    export default {
        name: 'App',

        data: () => ({
            //
        }),
    };
</script>

<style lang='scss'>
	#app {
		min-width: 320px;
		overflow: hidden;
	}
</style>